import React from "react";

import {
  LayoutTable,
  LayoutThead,
} from "../../components/layouts/Table";

import KritikSaranStatusBadge from "./KritikSaranStatusBadge";

const KritikSaranTable = ({
  data = {},
  onDetail = () => {},
  onDisposisi = () => {},
  onTindakLanjut = () => {},
  showAction = true,
}) => {
  return (
    <>
      {data.data && data.data.length > 0 && (
        <LayoutTable>
          <LayoutThead>
            {/* NO */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              No
            </th>

            {/* KODE */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              Kode
            </th>

            {/* KATEGORI */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              Kategori
            </th>

            {/* JUDUL */}
            <th className="py-1 bg-primary text-white border-silver fw-normal">
              Judul
            </th>

            {/* TUJUAN */}
            <th className="py-1 bg-primary text-white border-silver fw-normal">
              Tujuan
            </th>

            {/* STATUS */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              Status
            </th>

            {/* PENGIRIM */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              Pengirim
            </th>

            {/* TANGGAL */}
            <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
              Tanggal
            </th>

            {/* ACTION */}
            {showAction && (
              <th className="py-1 bg-primary text-white border-silver fw-normal text-center">
                <i className="fa fa-fw fa-cog" />
              </th>
            )}
          </LayoutThead>

          <tbody>
            {data.data.map((k, index) => {
              return (
                <tr key={index}>
                  {/* NO */}
                  <td className="py-1 border-silver text-center text-nowrap">
                    {(data.from || 1) + index}
                  </td>

                  {/* KODE */}
                  <td className="py-1 border-silver text-center text-nowrap">
                    {k.kode}
                  </td>

                  {/* KATEGORI */}
                  <td
                    className="py-1 border-silver text-center text-nowrap"
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {k.kategori}
                  </td>

                  {/* JUDUL */}
                  <td className="py-1 border-silver">
                    <div
                      className="fw-semibold"
                      style={{
                        maxWidth: "300px",
                      }}
                    >
                      {k.judul?.length > 60
                        ? `${k.judul.substring(0, 60)}...`
                        : k.judul}
                    </div>

                    {/* <small className="text-muted">
                      {k.is_anonim
                        ? "Anonim"
                        : k.pengirim_type}
                    </small> */}
                  </td>

                  {/* TUJUAN */}
                  <td className="py-1 border-silver text-nowrap">
                    {/* PEGAWAI */}
                    {k.tujuan_type === "pegawai" && (
                      <div>
                        <small className="text-muted">
                          Pegawai
                        </small>
                        <div>
                          {k.tujuan_pegawai?.nama}
                        </div>                        
                      </div>
                    )}

                    {/* DOSEN */}
                    {k.tujuan_type === "dosen" && (
                      <div>
                        <small className="text-muted">
                          Dosen
                        </small>
                        <div>
                          {k.tujuan_dosen?.nama}
                        </div>
                      </div>
                    )}

                    {/* GROUP */}
                    {k.tujuan_type === "group" && (
                      <div>
                        <small className="text-muted">
                          Group
                        </small>
                        <div>
                          {k.tujuan_manual}
                        </div>
                      </div>
                    )}

                    {/* UMUM */}
                    {k.tujuan_type === "umum" && (
                      <div>
                        <small className="text-muted">
                          Umum
                        </small>
                        <div>
                          {k.tujuan_manual}
                        </div>
                      </div>
                    )}
                  </td>

                  {/* STATUS */}
                  <td className="py-1 border-silver text-center text-nowrap">
                    <KritikSaranStatusBadge
                      status={k.status}
                    />
                  </td>

                  {/* PENGIRIM */}
                  <td
                    className="py-1 border-silver text-center text-nowrap"
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {k.is_anonim ? (
                      <small className="text-muted">
                          Disembunyikan
                      </small>
                    ) : (
                      <>
                        <div>
                          {k.pengirim_type === "pegawai" &&
                            k.pengirim_pegawai?.nama}

                          {k.pengirim_type === "mahasiswa" &&
                            k.pengirim_mahasiswa?.nama}

                          {k.pengirim_type === "dosen" &&
                            k.pengirim_dosen?.nama}
                        </div>

                        <small className="text-muted">
                          {k.pengirim_type}
                        </small>
                      </>
                    )}
                  </td>

                  {/* TANGGAL */}
                  <td className="py-1 border-silver text-center text-nowrap">
                    <div title="Tanggal dibuat">
                      {new Date(k.created_at).toLocaleDateString(
                        "id-ID",
                        {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </td>

                  {/* ACTION */}
                  {showAction && (
                    <td className="py-1 border-silver text-center text-nowrap">
                      <div className="d-flex justify-content-center gap-1">
                        {/* DETAIL */}
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          title="Detail"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDetail(k);
                          }}
                        >
                          <i className="fa fa-fw fa-eye" />
                        </button>

                        {/* DISPOSISI */}
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-info text-white"
                          title="Disposisi"
                          onClick={() => onDisposisi(k)}
                        >
                          <i className="fa fa-fw fa-share" />
                        </button> */}

                        {/* TINDAK LANJUT */}
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-success"
                          title="Tindak Lanjut"
                          onClick={() => onTindakLanjut(k)}
                        >
                          <i className="fa fa-fw fa-reply" />
                        </button> */}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </LayoutTable>
      )}
    </>
  );
};

export default KritikSaranTable;